// extracted by mini-css-extract-plugin
module.exports = {"question":"Question_question__3NqsF","answeredQuestion":"Question_answeredQuestion__3JAZE"};